export const ALLOWED_SIGN_HASH_TYPES = {
  DEFAULT: 0, // SIGHASH_DEFAULT - used for Taproot (P2TR) transactions
  ALL: 1,
  SINGLE_ANYONECANPAY: 131,
};

export const VERSION_BYTES = 4;
export const LOCK_TIME_BYTES = 4;
export const MARKER_FLAG_BYTES = 2;
// General
export const INPUT_COUNT_BYTE = 1;
export const INPUT_PREVIOUS_TX_HASH_BYTES = 32;
export const INPUT_VOUT_BYTES = 4;
export const INPUT_SCRIPTSIG_LENGTH_BYTES = 1;
export const INPUT_SEQUENCE_BYTES = 4;
// Legacy
export const INPUT_SCRIPTSIG_BYTES_LEGACY = 148; // https://bitcoin.stackexchange.com/questions/48279/how-big-is-the-input-of-a-p2pkh-transaction

// SegWit
export const INPUT_WITNESS_SCRIPTSIG_BYTES = 23; // includes RedeemScript
export const INPUT_WITNESS_STACK_ITEMS_COUNT_BYTE = 1;
export const INPUT_WITNESS_ITEM_LENGTH_BYTE = 1;
export const INPUT_WITNESS_SIG_BYTES = 72;
export const INPUT_WITNESS_PUBKEY_LENGTH_BYTE = 1;
export const INPUT_WITNESS_PUBKEY_BYTES = 33;

export const OUTPUT_COUNT_BYTE = 1;
export const OUTPUT_LENGTH_BYTE = 1;
export const OUTPUT_AMOUNT_BYTES = 8;
export const OUTPUT_SH_SCRIPT_PUBKEY_BYTES = 23; // a9 - OP_HASH160, 14 - 20 bytelength, …bytes…, 87 OP_EQUAL
export const OUTPUT_WPKH_SCRIPT_PUBKEY_BYTES = 23; // 16 - length, 00 - segwit version, 14 20 bytelength, …bytes…
export const OUTPUT_PKH_SCRIPT_PUBKEY_BYTES = 25; // OP_DUP OP_HASH160 20-bytes-pubkey-hash OP_EQUALVERIFY OP_CHECKSIG

export const OUTPUT_MULTISIG_OPS_BYTES = 3; // OP_2 + ...pubkey... + OP_2 + OP_CHECKMULTISIG = 3 extra bytes
export const OUTPUT_MULTISIG_PUBKEY_BYTES = 33;
export const OUTPUT_MULTISIG_PUBKEY_LENGTH_BYTES = 1;

export const OUTPUT_DEFAULT_SIZE_BYTES = 32;

/**
 * Bitcoin byte size limitation for arbitrary data in OP_RETURN
 * The limit on OP_RETURN output size is now applied to the entire serialized scriptPubKey, 83 bytes by default.
 * (the previous 80 byte default plus three bytes overhead)
 * OP_RETURN opcode 1byte
 * OP_PUSHDATA1 opcode 1byte
 * Number of data bytes that follow 1byte
 * https://github.com/bitcoin/bitcoin/blob/master/doc/release-notes/release-notes-0.12.0.md#relay-any-sequence-of-pushdatas-in-op_return-outputs-now-allowed
 *  */
export const OP_RETURN_BYTES = 80;
export const OP_RETURN_LENGTH_BYTE = 1;

/**
 * Hacky trick to embed data in MofN multisig, by pushing data as the pubkey
 * Per sig, each compressed wallet can carry 31 bytes of data
 * */
export const MOFN_MAX_EMBED_BYTES_PER_PUBKEY = 31;

/**
 * Witness scale factor adds weight to SigOps in tx body (LEGACY)
 * Not applied for SigOps present in p2sh or witness
 * https://github.com/bitcoin/bitcoin/blob/e8f72aefd20049eac81b150e7f0d33709acd18ed/src/consensus/consensus.h#L21
 *
 */
export const SIGOPS_WITNESS_SCALE_FACTOR = 4;

/**
 * Considered legacy and therefore always 20 SigOps as constant
 * https://github.com/bitcoin/bitcoin/blob/e8f72aefd20049eac81b150e7f0d33709acd18ed/src/script/script.h#L34
 */
export const SIGOPS_OUTPUT_BARE_MULTISIG_COUNT_LEGACY = 20;
/**
 * Considered legacy but still 1 SigOp as constant
 * Will have to be multiplied by the witness scale factor though
 */
export const SIGOPS_OUTPUT_PKH_COUNT_LEGACY = 1;

export const SIGOPS_INPUT_PKH_COUNT_LEGACY = 1;

export const P2PKH_INPUT_BYTE_SIZE_LEGACY =
  INPUT_PREVIOUS_TX_HASH_BYTES + // previous tx hash 32b
  INPUT_VOUT_BYTES + // previous tx output index 4b
  INPUT_SCRIPTSIG_LENGTH_BYTES + // scriptSig length 1b
  INPUT_SCRIPTSIG_BYTES_LEGACY + // scriptSig length 148b
  INPUT_SEQUENCE_BYTES; // sequence 4b

/*
 * This calculation is based on constants for a P2SH-P2WPKH Bitcoin transaction
 * In case of decomposition of the input:
 * WitnessData, as well as ScriptSig, are not included in the provided input yet
 * They will be set after the signature
 */
export const P2SH_P2WPKH_INPUT_BYTE_SIZE =
  INPUT_PREVIOUS_TX_HASH_BYTES + // previous tx hash 32b
  INPUT_VOUT_BYTES + // previous tx output index 4b
  INPUT_SCRIPTSIG_LENGTH_BYTES + // scriptSig length 1b
  INPUT_WITNESS_SCRIPTSIG_BYTES + // scriptSig length 23b
  INPUT_SEQUENCE_BYTES; // sequence 4b

export const P2SH_P2WPKH_INPUT_WITNESS_BYTE_SIZE =
  INPUT_WITNESS_STACK_ITEMS_COUNT_BYTE + // witness stack items count 1b
  INPUT_WITNESS_ITEM_LENGTH_BYTE + // signature length 1b
  INPUT_WITNESS_SIG_BYTES + // signature length 72b
  INPUT_WITNESS_PUBKEY_LENGTH_BYTE + // pubkey length 1b
  INPUT_WITNESS_PUBKEY_BYTES; // pubkey length 33b

// Enables RBF
export const RBF_INPUT_SEQUENCE = 0xffffffff - 2;
// Max sequence = disables RBF
export const DEFAULT_INPUT_SEQUENCE = 0xffffffff;
